(() => {
  if (window.bbNovemberDialogBound) return;
  window.bbNovemberDialogBound = true;
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-bb-november-open]');
    if (!link) return;
    const dialog = document.getElementById('bb-november-terms');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    event.preventDefault();
    dialog.showModal();
  });
})();
